import groupModule from '../groupModule';

function groupData() {
    "ngInject";
    return {
        restrict: "A",
        link: function (scope) {
            scope.Data = {
                activeTab: "about"
            };
        }
    }
};

groupModule.directive("groupData", groupData);

export default groupData;